import { getBudgetEpProjectPoolManageList } from '../services';

export default {
  namespace: 'projectReserveManage',
  state: {},
  effects: {
    // 项目储备管理列表
    *getBudgetEpProjectPoolManageList({ payload }, { call }) {
      return yield call(getBudgetEpProjectPoolManageList, payload);
    },
  },
  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
